<div class="body org-chart-body org-chart-scroll">
  <div class="org-chart-tree">
    <ul>
      <ng-container *ngTemplateOutlet="orgNode; context:{ $implicit: data }"></ng-container>
    </ul>
  </div>
</div>

<ng-template #orgNode let-node>
  <li>
    <a href="" (click)="displayChildren($event, node)">
      <div class="member-view-box">
        <div class="orgParent">
          <div class="orgHeader" [ngClass]="{'orgHeaderParent': node.isFirstNode}">
            <div *ngIf="!node.isFirstNode" class="editButton" (click)="editSection($event,node)">
              <i class="material-icons editIcon">mode</i>
            </div>

            <p class="pt-2" [ngStyle]="{
              'font-size': node.isFirstNode ? '1.3em' : 'inherit',
              'padding-left': node.isFirstNode ? '1em' : 'inherit',
              'padding-right': node.isFirstNode ? '1em' : 'inherit'
            }">
              {{node.area}}
            </p>
          </div>
          <div class="m-2 orgData" *ngIf="!node.isFirstNode">
            <p>
              <span *ngIf="node.validatorProfileImage">
                <img
                  [src]="'data:' + node.validatorProfileImage.mimeType + ';base64,' + node.validatorProfileImage.imageData"
                  class="profileImage" />
              </span>
              Responsable:
              {{ node.validatorName ? node.validatorName : 'Sin responsable' }}
              <span *ngIf="node.validatorName">({{ node.validatorPosition }})</span>
            </p>
            <p *ngIf="node.delegateResponsibleName">
              <span *ngIf="node.delegateResponsibleProfileImage">
                <img
                  [src]="'data:' + node.delegateResponsibleProfileImage.mimeType + ';base64,' + node.delegateResponsibleProfileImage.imageData"
                  class="profileImage" />
              </span>
              Responsable Delegado: {{node.delegateResponsibleName}}
              ({{node.delegateResponsiblePosition}})
            </p>
            <p *ngIf="node.dualResponsibleName">
              <span *ngIf="node.dualResponsibleProfileImage">
                <img
                  [src]="'data:' + node.dualResponsibleProfileImage.mimeType + ';base64,' + node.dualResponsibleProfileImage.imageData"
                  class="profileImage" />
              </span>
              Responsable Doble: {{node.dualResponsibleName}}
              ({{node.dualResponsiblePosition}})
            </p>

          </div>
        </div>
        <div *ngIf="node.children" class="toggleButton">
          <i *ngIf="!node.isOpen" class="material-icons">add</i>
          <i *ngIf="node.isOpen" class="material-icons">remove</i>
        </div>
      </div>

    </a>
    <ul *ngIf="node.children" [@fadeInOut] [hidden]="!node.isOpen">
      <ng-container *ngFor="let child of node.children">
        <ng-container *ngTemplateOutlet="orgNode; context:{ $implicit: child }"></ng-container>
      </ng-container>
    </ul>
  </li>
</ng-template>